var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33196 13.2786L9.62687 16.5474C9.76136 16.6808 9.82591 16.8365 9.82053 17.0144C9.81515 17.1923 9.74499 17.348 9.61006 17.4814C9.47557 17.6037 9.31867 17.6677 9.13936 17.6735C8.96004 17.6793 8.80314 17.6152 8.66866 17.4814L4.23061 13.0784C4.16337 13.0117 4.11563 12.9395 4.08739 12.8616C4.05914 12.7838 4.04547 12.7004 4.04637 12.6115C4.04637 12.5225 4.06049 12.4391 4.08873 12.3613C4.11697 12.2835 4.16427 12.2112 4.23061 12.1445L8.66866 7.74156C8.79193 7.61926 8.94614 7.55811 9.13129 7.55811C9.31643 7.55811 9.47602 7.61926 9.61006 7.74156C9.74454 7.87498 9.81179 8.03353 9.81179 8.21721C9.81179 8.40089 9.74454 8.55922 9.61006 8.69219L6.33196 11.9444H20.5707C20.7612 11.9444 20.921 12.0084 21.0501 12.1365C21.1792 12.2646 21.2436 12.4229 21.2431 12.6115C21.2431 12.8005 21.1786 12.959 21.0494 13.0871C20.9203 13.2152 20.7608 13.279 20.5707 13.2786H6.33196Z",
    fill: "#1D2739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlack);
export default __webpack_public_path__ + "static/media/arrowBackBlack.b51e5f8e8e80efb4a2a7100817bfb679.svg";
export { ForwardRef as ReactComponent };